export enum Emotion {
  Frustrated = "FRUSTRATED",
  Confused = "CONFUSED",
  Bored = "BORED",
  Neutral = "NEUTRAL",
}